import {
  useWSModalCustom,
  WSElement,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { RequirementDefinition } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

type Props = {
  requirementDefinition: RequirementDefinition;
} & WSModalCustomProps<boolean>;

export const ModalCreateNewVersion: React.FC<Props> = ({
  requirementDefinition,
  ...modalProps
}) => {
  return (
    <WSModal
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: () => modalProps.onClose(false),
            type: "button"
          },
          {
            kind: "Primary",
            label: "Continue",
            onClick: () => modalProps.onClose(true)
          }
        ]
      }}
      size="M"
      title="Create new version"
      {...modalProps}
    >
      <WSList gap="XL">
        <WSElement>
          <WSText.ParagraphSm mb="XS" weight="bold">
            Important:
          </WSText.ParagraphSm>
          <WSText.ParagraphSm color="gray500">
            Here&apos;s what to expect when creating a new version of a
            requirement.
          </WSText.ParagraphSm>
        </WSElement>

        <WSText.ParagraphSm as="div" color="gray500">
          <WSElement as="ul" pl="M">
            <li>
              The settings between versions must be different in order for a new
              version to be saved (e.g. approval, expiration, and/or other
              requirement settings).
            </li>
            <li>
              You will decide who is impacted by the new version, if applicable.
            </li>
            <li>
              You will decide how the affected contractors will transition to
              the new version, if applicable.
            </li>
          </WSElement>
        </WSText.ParagraphSm>

        <WSText.ParagraphSm color="gray500">
          If you only wish to change the display name or description but keep
          all settings the same, go back to edit the requirement instead.
        </WSText.ParagraphSm>

        <WSInfoBox>
          Current version: v{requirementDefinition.version}
          {requirementDefinition.versionNote ? (
            <>
              <br />
              Note: {requirementDefinition.versionNote}
            </>
          ) : null}
        </WSInfoBox>
      </WSList>
    </WSModal>
  );
};

export const useCreateNewVersionModal = () =>
  useWSModalCustom(ModalCreateNewVersion);
